<template>
    
    <div class="content-area__inner no-padding no-scroll-y">
        
        <ContentAreaTitle
            ref="titleBar"
            :title="$store.getters.client.name"
            :subtitle="$store.getters.client.description ? $store.getters.client.description : 'N/A'"
            :tabs="$router.options.routes[1].children[1].children">
        </ContentAreaTitle>
        
        <router-view :style="{
            'position': 'absolute',
            'height': 'auto',
            'margin-top': `${this.titleBarHeight}px`,
            'top': 0,
            'right': 0,
            'bottom': 0,
            'left': 0
        }" key="client"></router-view>
        
    </div>
    
</template>

<script>
    
    import ContentAreaTitle from "@/components/ContentAreaTitle.vue";
    
    export default {
        
        components: { ContentAreaTitle },
        
        data() {
            return {
                titleBarHeight: 0,
            }
        },
        
        mounted() {
			
			// Update title bar height.
			
			this.titleBarHeight = this.$refs.titleBar.$el.clientHeight;
			
			// Refresh project data.
			
			this.$store.dispatch("refreshSelectedClient", { slug: this.$route.params.clientSlug });
			
        }
        
    }
    
</script>

<style>
    
    
    
</style>



// WEBPACK FOOTER //
// src/components/Clients/Client.vue